import { IMAGE_LOADER, type ImageLoaderConfig } from '@angular/common';
import {
  DOCUMENT,
  inject,
  provideAppInitializer,
  type Provider,
} from '@angular/core';

import { injectConfigProperty } from '@cosmos/config';
import { createImgixLoader } from '@cosmos/util-imgix';

const injectImgixUrl = () => injectConfigProperty('storefrontImgixUrl');

export function provideImageLoader(): Provider[] {
  return [
    ngServerMode
      ? [
          provideAppInitializer(() => {
            // Add imgix preconnect link
            const imgixUrl = injectImgixUrl();
            const document = inject(DOCUMENT);

            if (imgixUrl) {
              const linkElement = document.createElement('link');
              linkElement.rel = 'preconnect';
              linkElement.href = imgixUrl;
              document.head.appendChild(linkElement);
            }
          }),
        ]
      : [],
    {
      provide: IMAGE_LOADER,
      useFactory: () => {
        const imgixUrl = injectImgixUrl();
        const imgixImageLoader = createImgixLoader(imgixUrl);

        return (config: ImageLoaderConfig) => {
          const src = config.src;

          // ngSrc is typed string but some data from api is not, so it crashed on startsWith
          // Return src in case image is not hosted on imgix platform
          if (typeof src !== 'string' || !src.startsWith(imgixUrl)) {
            return src;
          }

          return imgixImageLoader({
            ...config,
            src: src.replace(imgixUrl!, ''),
          });
        };
      },
    },
  ];
}
